import { supabase } from '@/lib/supabase';
import type { SupabaseClient } from '@/lib/supabase';

// Check if Supabase is properly configured
let supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.SUPABASE_URL || '';
if (supabaseUrl.includes('=')) {
  supabaseUrl = supabaseUrl.split('=')[1] || '';
}
const isSupabaseConfigured = supabaseUrl.startsWith('https://') && supabaseUrl.includes('.supabase.co');

/**
 * Delete a branch
 */
export async function deleteBranch(id: string): Promise<void> {
  if (!isSupabaseConfigured || !supabase) {
    // Return without error in demo mode
    console.log('[Demo] Would delete branch:', id);
    return;
  }

  const supabaseClient = supabase as SupabaseClient;
  
  const { error } = await supabaseClient
    .from('branches')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Error deleting branch:', error);
    throw new Error(error.message);
  }
}